
import { Prop, Vue, Component } from 'vue-property-decorator';
import { ActivityDescInfo } from './types';
import { i18n } from './i18n';
@Component({})
export default class ActivityDesc extends Vue {
  /** 活动说明信息 */
  @Prop() activityDescInfo!: ActivityDescInfo;
  /** 默认 title */
  public defaultTitle = i18n('活動說明');
}
